/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-20-05 06:08:32
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';

export const GET_AVAILABLE_SORT_TYPES_REQUEST = 'GET_AVAILABLE_SORT_TYPES_REQUEST';
type GET_AVAILABLE_SORT_TYPES_REQUEST_TYPE = 'GET_AVAILABLE_SORT_TYPES_REQUEST';

export const GET_AVAILABLE_SORT_TYPES_SUCCESS = 'GET_AVAILABLE_SORT_TYPES_SUCCESS';
type GET_AVAILABLE_SORT_TYPES_SUCCESS_TYPE = 'GET_AVAILABLE_SORT_TYPES_SUCCESS';

export const GET_AVAILABLE_SORT_TYPES_FAILURE = 'GET_AVAILABLE_SORT_TYPES_FAILURE';
type GET_AVAILABLE_SORT_TYPES_FAILURE_TYPE = 'GET_AVAILABLE_SORT_TYPES_FAILURE';

export const GET_CUSTOM_SORTING_REQUEST = 'GET_CUSTOM_SORTING_REQUEST';
type GET_CUSTOM_SORTING_REQUEST_TYPE = 'GET_CUSTOM_SORTING_REQUEST';

export const GET_CUSTOM_SORTING_SUCCESS = 'GET_CUSTOM_SORTING_SUCCESS';
type GET_CUSTOM_SORTING_SUCCESS_TYPE = 'GET_CUSTOM_SORTING_SUCCESS';

export const GET_CUSTOM_SORTING_FAILURE = 'GET_CUSTOM_SORTING_FAILURE';
type GET_CUSTOM_SORTING_FAILURE_TYPE = 'GET_CUSTOM_SORTING_FAILURE';

export const UPDATE_CUSTOM_SORTING_REQUEST = 'UPDATE_CUSTOM_SORTING_REQUEST';
type UPDATE_CUSTOM_SORTING_REQUEST_TYPE = 'UPDATE_CUSTOM_SORTING_REQUEST';

export const UPDATE_CUSTOM_SORTING_SUCCESS = 'UPDATE_CUSTOM_SORTING_SUCCESS';
type UPDATE_CUSTOM_SORTING_SUCCESS_TYPE = 'UPDATE_CUSTOM_SORTING_SUCCESS';

export const UPDATE_CUSTOM_SORTING_FAILURE = 'UPDATE_CUSTOM_SORTING_FAILURE';
type UPDATE_CUSTOM_SORTING_FAILURE_TYPE = 'UPDATE_CUSTOM_SORTING_FAILURE';

type CustomSortingSuccess = {
  data: Object
};

type CustomSortingFailure = {
  error: any
};

type AvailableSortTypesSuccess = {
  data: Object,
  i18n: Object
};

type AvailableSortTypesFailure = {
  error: any
};

type GetAvailableSortTypesRequestAction = Action<GET_AVAILABLE_SORT_TYPES_REQUEST_TYPE, null>;

type GetAvailableSortTypesSuccessAction = Action<
  GET_AVAILABLE_SORT_TYPES_SUCCESS_TYPE,
  AvailableSortTypesSuccess
>;

type GetAvailableSortTypesFailureAction = Action<
  GET_AVAILABLE_SORT_TYPES_FAILURE_TYPE,
  AvailableSortTypesFailure
>;

type GetCustomSortingRequestAction = Action<GET_CUSTOM_SORTING_REQUEST_TYPE, null>;

type GetCustomSortingSuccessAction = Action<GET_CUSTOM_SORTING_SUCCESS_TYPE, CustomSortingSuccess>;

type GetCustomSortingFailureAction = Action<GET_CUSTOM_SORTING_FAILURE_TYPE, CustomSortingFailure>;

type UpdateCustomSortingRequestAction = Action<UPDATE_CUSTOM_SORTING_REQUEST_TYPE, null>;

type UpdateCustomSortingSuccessAction = Action<
  UPDATE_CUSTOM_SORTING_SUCCESS_TYPE,
  CustomSortingSuccess
>;

type UpdateCustomSortingFailureAction = Action<
  UPDATE_CUSTOM_SORTING_FAILURE_TYPE,
  CustomSortingFailure
>;

export type CustomSortingAction =
  | GetAvailableSortTypesRequestAction
  | GetAvailableSortTypesSuccessAction
  | GetAvailableSortTypesFailureAction
  | GetCustomSortingRequestAction
  | GetCustomSortingSuccessAction
  | GetCustomSortingFailureAction
  | UpdateCustomSortingRequestAction
  | UpdateCustomSortingSuccessAction
  | UpdateCustomSortingFailureAction;

export type CustomSortingState = {
  getSortTypesLoading: boolean,
  getSortTypesSuccess: boolean,
  loading: boolean,
  saving: boolean,
  saveSuccess: boolean,
  error: any,
  sortByOptions: Array<Object>,
  sortTypes: Array<Object>,
  scheduleSyncIn: number,
  scheduleSyncAfter: number,
  waitSyncAt: number
};
